import { Container, Row } from "reactstrap";
import { AdvanceInitTitle, DataTitle } from "../../../../../constants";
import RowCreateCallback from "./RowCreateCallback";
import StockResult from "./StockResult";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const AdvanceInitContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AdvanceInitTitle} parent={DataTitle} />
      <Container fluid>
        <Row>
          <StockResult />
          <RowCreateCallback />
        </Row>
      </Container>
    </>
  );
};
export default AdvanceInitContainer;
